import Main from '@/views/administracion/obrassolicitudes/Main.vue';
import Default from '@/views/administracion/obrassolicitudes/Default.vue';
import Configuracion from './configuracion';

// auth y scopes de planeacion
const auth = ['Planeación:ver'];
const scopes = ['Planeación:crear', 'Planeación:editar', 'Planeación:eliminar'];

const solicitiudesObras = [
  {
    path: 'solicitudes-obras',
    meta: {
      title: '',
      auth,
    },
    component: Main,
    children: [
      ...Configuracion,
      {
        name: 'solicitudesObras',
        path: '/',
        meta: {
          title: 'Solicitudes de Obras',
          auth,
          scopes,
        },
        component: Default,

        children: [],
      },
    ],
  },
];

export default solicitiudesObras;
